export const getRegardedAccountingPeriodsSection = (excelData) => {
  return [
    excelData.compNames,
    excelData.APSD,
    excelData.APED,
    excelData.period_length,
    excelData.date_joined,
    excelData.date_lefted,
    excelData.regarded_period,
    excelData.disregarded_percent,
    [],
    excelData.currency,
    excelData.fx,
    [],
    ["Net tax-interest expense/(income) section"],
    [],
    ["Non-trading loan relationships"],
    excelData.nltr_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.nltr_exclude_exchange_gains_losses,
    excelData.nltr_exclude_impairment_gains_losses,
    excelData.nltr_exclude_tax_interest_income_double_relief,
    excelData.nltr_adjustment_amortised_cost_basis,
    excelData.nltr_adjustment_qualifying_election,
    excelData.nltr_exclude_defined_benefit_pension,
    excelData.nltr_bank_expenses,
    excelData.nltr_adjustment_gaap_transition,
    excelData.nltr_adjustment_lease_finance_cost,
    excelData.nltr_other_adjustments_1,
    excelData.nltr_other_adjustments_2,
    excelData.nltr_other_adjustments_3,
    excelData.ntlr_subtotal,
    [],
    ["Non-trading derivative contracts"],
    excelData.ntdc_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.ntdc_exclude_exchange_gains_losses,
    excelData.ntdc_exclude_impairment_gains_losses,
    excelData.ntdc_exclude_tax_interest_income_double_relief,
    excelData.ntdc_exclude_ordinary_trade,
    excelData[
      "ntdc_exclude_derivatives_without_subject_matters_384(4)_s387(4)"
    ],
    excelData.ntdc_adjustment_qualifying_election,
    excelData.ntdc_adjustment_gaap_transition,
    excelData.ntdc_adjustment_disregard_regulations,
    excelData.ntdc_other_adjustments_1,
    excelData.ntdc_other_adjustments_2,
    excelData.ntdc_other_adjustments_3,
    excelData.ntdc_subtotal,
    [],
    ["Trading loan relationships"],
    excelData.tlr_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.tlr_exclude_exchange_gains_losses,
    excelData.tlr_exclude_impairment_gains_losses,
    excelData.tlr_exclude_tax_interest_income_double_relief,
    excelData.tlr_adjustment_amortised_cost_basis,
    excelData.tlr_adjustment_qualifying_election,
    excelData.tlr_exclude_defined_benefit_pension,
    excelData.tlr_bank_expenses,
    excelData.tlr_adjustment_gaap_transition,
    excelData.tlr_adjustment_lease_finance_cost,
    excelData.tlr_other_adjustments_1,
    excelData.tlr_other_adjustments_2,
    excelData.tlr_other_adjustments_3,
    excelData.tlr_subtotal,
    [],
    ["Trading derivative contracts"],
    excelData.tdc_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.tdc_exclude_exchange_gains_losses,
    excelData.tdc_exclude_impairment_gains_losses,
    excelData.tdc_exclude_tax_interest_income_double_relief,
    excelData.tdc_exclude_ordinary_trade,
    excelData["tdc_exclude_derivatives_without_subject_matters_384(4)_s387(4)"],
    excelData.tdc_adjustment_qualifying_election,
    excelData.tdc_adjustment_gaap_transition,
    excelData.tdc_adjustment_disregard_regulations,
    excelData.tdc_other_adjustments_1,
    excelData.tdc_other_adjustments_2,
    excelData.tdc_other_adjustments_3,
    excelData.tdc_subtotal,
    [],
    ["Other financing arrangements"],
    excelData.ofa_total_per_source_sheet_for_period,
    excelData.note_1,
    excelData.ofa_exclude_tax_interest_income_double_relief,
    excelData.ofa_adjustment_qualifying_election,
    excelData.ofa_adjustment_gaap_transition,
    excelData.ofa_adjustment_finance_lease,
    excelData.ofa_adjustment_debt_factoring,
    excelData.ofa_adjustment_service_concession,
    excelData.ofa_other_adjustments_1,
    excelData.ofa_other_adjustments_2,
    excelData.ofa_other_adjustments_3,
    excelData.ofa_subtotal,
    [],
    excelData.net_tax_interest_totals,
    excelData.net_tax_interest_expense_gbp,
    [],
    [],
    [],
    ["Tax-EBITDA section"],
    excelData.cte_condition_a,
    excelData.cte_condition_b,
    excelData.cte_restrictions_reactivations_included,
    excelData.tebitda_adjustments,
    excelData.cte_subtotal,
    [],
    ["Adjustments - s407 TIOPA 2010"],
    excelData.s407_tiopa_net_tax_interest_expense,
    excelData.s407_tiopa_capital_allowance_charges,
    excelData.s407_tiopa_relevant_intangible_debits_credits,
    excelData.s407_tiopa_adjustment_intangible_debit_credits,
    excelData.s407_tiopa_other_period_losses,
    excelData.s407_tiopa_loan_relationship_deficts_other_periods,
    excelData.s407_tiopa_expenses_management_other_periods,
    excelData.s407_tiopa_group_relief,
    excelData.s407_relief_rd_expenditure_credit,
    excelData.s407_relief_rd_additional_relief,
    excelData.s407_relief_trading_loss,
    excelData.s407_relief_contaminated_land_relief,
    excelData.s407_relief_creative_industries,
    excelData.s407_relief_charitable_donation,
    excelData.s407_relief_patent_box_profits,
    excelData.s407_relief_dtr_adjustment_tax_rate_equal_uk,
    excelData.s407_relief_adjustment_qualifying_infrastructure,
    excelData.s407_relief_adjustment_gaap_items,
    excelData.s407_relief_finance_lease_depreciation,
    excelData.s407_relief_reversal_of_lease_depreciation,
    excelData.s407_relief_long_funding_lease_deduction,
    excelData.s407_relief_finance_lease_rentals_receivable,
    excelData.s407_relief_long_funding_lessee,
    excelData.s407_relief_adjustment_misc_losses,
    excelData.s407_relief_group_relief,
    excelData.s407_relief_adjustment_disregarded_regulations,
    excelData.s407_relief_other_adjustments_1,
    excelData.s407_relief_other_adjustments_2,
    excelData.s407_relief_other_adjustments_3,
    excelData.tax_ebitda,
    excelData.tax_ebitda_gbp,
  ];
};
